import { render, staticRenderFns } from "./ChronicAbsenceRateChart.vue?vue&type=template&id=845670fc&scoped=true"
import script from "./ChronicAbsenceRateChart.vue?vue&type=script&lang=js"
export * from "./ChronicAbsenceRateChart.vue?vue&type=script&lang=js"
import style0 from "./ChronicAbsenceRateChart.vue?vue&type=style&index=0&id=845670fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845670fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VMenu,VSpacer})
